import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { VenueShows } from "./components/VenueShows";
import { ListShows } from "./components/ListShows";
import { ListVenues } from "./components/ListVenues";
import { Admin } from "./components/Admin";
import { AppMenu } from "./components/AppMenu";
import { Instructions } from "./components/Instructions";
import GalleryForm from "./components/GalleryForm";
import EventForm from "./components/EventForm";
import { ImageUpload } from "./components/ImageUpload";
import { GoogleMap } from "./components/map/GoogleMap";
import { CalendarIcon } from "@heroicons/react/solid";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { GET_PINS } from "./libraries/queries.jsx";

export const App = () => {
  const [userPosition, setUserPosition] = useState([]);
  const [mapCenter, setMapCenter] = useState({
    lat: 29.651947,
    lng: -82.325004,
  });
  const [initialPositionSelected, setInitialPositionSelected] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [selectedVenue, setSelectedVenue] = useState("");

  let monthAhead = new Date(new Date().setMonth(new Date().getMonth() + 6));
  let monthsPrevious = new Date(new Date().setMonth(new Date().getMonth() - 3));
  const [value, onChange] = useState([monthsPrevious, monthAhead]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        if (initialPositionSelected === false) {
          setUserPosition([
            position.coords.latitude,
            position.coords.longitude,
          ]);
          setMapCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          setInitialPositionSelected(true);
        }
      });
      return;
    }
    return;
  }, [initialPositionSelected]);

  return (
    <Router>
      <Switch>
        <div className="comp relative w-full h-screen overflow-hidden">
          <div className="fixed top-0 z-30 w-full h-16 flex items-center justify-end glass">
            <AppMenu setDrawerOpen={setDrawerOpen} />
            <div className="flex relative w-2/3 h-full items-center justify-end py-2 hidden">
              <DateRangePicker
                className={`absolute shadow-md w-full p-0 transition-all ease-in-out ${
                  calendarOpen ? "left-0 h-full" : "-right-full h-0"
                }`}
                onChange={onChange}
                value={value}
                calendarIcon={null}
                clearIcon={null}
              />
              <CalendarIcon
                className={`w-8 h-8 razz-fill mx-2 ${
                  calendarOpen ? "opacity-100" : "opacity-75"
                }`}
                onClick={() => setCalendarOpen(!calendarOpen)}
              />
            </div>
          </div>
          <Route exact path="/portal/venues">
            <GalleryForm />
          </Route>
          <Route path="/portal/events/:portalVenue">
            <EventForm />
          </Route>
          <Route path="/portal/admin">
            <Admin />
          </Route>
          <div className="w-full h-screen fixed z-0 overflow-hidden">
            <GoogleMap
              mapCenter={mapCenter}
              setMapCenter={setMapCenter}
              mapQuery={GET_PINS}
              zoomLevel={14}
              setSelectedVenue={setSelectedVenue}
              selectedVenue={selectedVenue}
              drawerOpen={drawerOpen}
              setDrawerOpen={setDrawerOpen}
              userPosition={userPosition}
              setUserPosition={setUserPosition}
            />
          </div>
          <Instructions />
          <div
            className={`absolute w-full bottom-0 left-0 z-10 ${
              drawerOpen ? "" : ""
            }`}
          >
            <div>
              <div className="">
                <Switch>
                  <Route exact path="/">
                    <VenueShows
                      selectedVenue={selectedVenue}
                      setSelectedVenue={setSelectedVenue}
                      drawerOpen={drawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </Route>
                  <Route path="/events">
                    <ListShows
                      onchange={onchange}
                      value={value}
                      selectedVenue={selectedVenue}
                      setSelectedVenue={setSelectedVenue}
                      userPosition={userPosition}
                    />
                  </Route>
                  <Route path="/venues">
                    <VenueShows
                      selectedVenue={selectedVenue}
                      setSelectedVenue={setSelectedVenue}
                      drawerOpen={drawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </Route>
                  <Route path="/allvenues">
                    <ListVenues
                      selectedVenue={selectedVenue}
                      setSelectedVenue={setSelectedVenue}
                      userPosition={userPosition}
                    />
                  </Route>
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </Switch>
    </Router>
  );
};
